import * as Types from './types';
export function updateTheme(theme) {
    var action = {
        type: Types.UPDATE_THEME,
        theme: theme,
    };
    return action;
}
